import React from 'react';
import { Dialog, Typography, Box } from '@mui/material';

interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
  icon: React.ReactNode;
  heading: string;
  subheading: string;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({
  open,
  onClose,
  icon,
  heading,
  subheading,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth='xs'
    fullWidth
    PaperProps={{
      sx: { borderRadius: '24px', padding: '30px' },
    }}
  >
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      pt={2}
      pb={4}
    >
      <Box
        sx={{
          width: '231px',
          height: '231px',
          borderRadius: '50%',
          bgcolor: '#D9D9D9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
        }}
      >
        {icon}
      </Box>
      <Typography
        sx={{ fontSize: 40, fontWeight: 'bold' }}
        align='center'
        gutterBottom
      >
        {heading}
      </Typography>
      <Typography sx={{ fontSize: 18, color: '#515151' }} align='center'>
        {subheading}
      </Typography>
    </Box>
  </Dialog>
);

export default SuccessDialog;
